var map = {
	"./bat": 917,
	"./coffee": 918,
	"./cpp": 919,
	"./csharp": 920,
	"./css": 921,
	"./dockerfile": 922,
	"./fsharp": 923,
	"./go": 924,
	"./handlebars": 925,
	"./html": 926,
	"./ini": 927,
	"./java": 928,
	"./less": 929,
	"./lua": 930,
	"./markdown": 931,
	"./monaco.contribution": 297,
	"./msdax": 932,
	"./objective-c": 933,
	"./php": 934,
	"./postiats": 935,
	"./powershell": 936,
	"./pug": 937,
	"./python": 938,
	"./r": 939,
	"./razor": 940,
	"./ruby": 941,
	"./sb": 942,
	"./scss": 943,
	"./solidity": 944,
	"./sql": 945,
	"./swift": 946,
	"./vb": 947,
	"./xml": 948,
	"./yaml": 949
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 916;


//////////////////
// WEBPACK FOOTER
// ./submodules/monaco-languages/src
// module id = 916
// module chunks = 0